import { useState, type FormEvent } from 'react';
import { ToggleFilterButton } from '@shared/ui';
import { Collapse, Flex, Button, Box, Text } from '@mantine/core';
import { IconCheck, IconTrash } from '@tabler/icons-react';
import classes from './FiltersBlock.module.scss';

type FiltersBlockProps = {
  children: React.ReactNode;
  onReset?: () => void;
  onSubmit?: (e: FormEvent<HTMLFormElement>) => void;
  isControllButtons?: boolean;
  activeFiltersCount?: number;
  defaultOpened?: boolean;
  onToggle?: (isOpened: boolean) => void;
};

export const FiltersBlock = ({
  children,
  onReset,
  onSubmit,
  isControllButtons = true,
  activeFiltersCount = 0,
  defaultOpened = false,
  onToggle,
}: FiltersBlockProps) => {
  const [isOpened, setIsOpened] = useState(defaultOpened);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit?.(e);
  };

  const handleToggle = () => {
    setIsOpened(!isOpened);

    onToggle && onToggle(isOpened);
  };

  const handleReset = () => {
    if (onReset) {
      onReset();
    }
  };

  return (
    <Flex direction='column'>
      <ToggleFilterButton isOpened={isOpened} onClick={handleToggle}>
        <Text fw={600}>Фильтры</Text>

        {activeFiltersCount !== 0 && (
          <Box className={classes.activeFiltersBlock}>{activeFiltersCount}</Box>
        )}
      </ToggleFilterButton>

      <Collapse in={isOpened}>
        <form onSubmit={handleSubmit}>
          {children}

          {isControllButtons && (
            <Flex gap={8} mt={16}>
              <Button
                leftSection={<IconTrash />}
                variant='gray'
                px={18}
                h={42}
                type='button'
                onClick={handleReset}
              >
                Сбросить
              </Button>
              <Button type='submit' leftSection={<IconCheck />} px={18} h={42}>
                Применить
              </Button>
            </Flex>
          )}
        </form>
      </Collapse>
    </Flex>
  );
};
